import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { useZusatzadresseList, Zusatzadresse, ZusatzadresseTyp } from 'api/zusatzadresse';
import { MenuPlacement } from 'react-select/src/types';
import { getZusatzadresseLabel } from 'utils/labels';

interface ZusatzadresseSelectProps {
    label: string;
    kNr?: number;
    typ?: ZusatzadresseTyp;
    zaNr?: number;
    zusatzadresse?: Zusatzadresse;

    onChange: (kaNr?: number, zusatzadresse?: Zusatzadresse) => void;
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    disabled?: boolean;
}

export const ZusatzadresseSelect: React.FC<ZusatzadresseSelectProps> = ({
    label = 'Zusatzadresse',
    kNr,
    typ,
    zaNr,
    zusatzadresse,
    allowEmpty = false,
    onChange,
    menuPlacement = 'bottom',
    disabled = false,
}) => {
    const zusatzadresseList = useZusatzadresseList(
        {
            kNr,
            typ,
            includeArchiv: true,
        },
        { enabled: kNr !== undefined },
    );

    const options = React.useMemo(() => {
        const o =
            zusatzadresseList?.data
                ?.filter((za) => !za.archiv)
                .sort((a, b) => (a.typ + a.combinedValues).localeCompare(b.typ + b.combinedValues))
                .map((a) => ({
                    value: a.nr.toString(),
                    label: getZusatzadresseLabel(a),
                })) || [];

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [zusatzadresseList, allowEmpty]);

    return (
        <div>
            <Label>{label}</Label>
            <Select
                name="zusatzadresse"
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={
                    zaNr
                        ? {
                              value: zaNr.toString(),
                              label: getZusatzadresseLabel(zusatzadresse),
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    const nr = parseInt(option?.value || '', 10);
                    onChange(
                        nr,
                        zusatzadresseList?.data?.find((za) => za.nr === nr),
                    );
                }}
            />
        </div>
    );
};
